import { ChoiceStatus } from '@payflip/utils';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { bodySmall } from '../../paragraph';

export const StyledOrderStatusTag = styled.div<{ status: ChoiceStatus }>`
  ${bodySmall};

  padding-left: ${({ theme }): string => theme.spacing_unit_x2};
  padding-right: ${({ theme }): string => theme.spacing_unit_x2};
  height: 36px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: ${({ theme }): string => theme.border_radius_infinite};
  width: fit-content;

  ${({ theme, status }): FlattenSimpleInterpolation => {
    switch (status) {
      case 'APPROVED': {
        return css`
          background-color: ${theme.palette_success_5};
        `;
      }
      case 'CANCELED': {
        return css`
          background-color: ${theme.palette_alert_5};
        `;
      }
      case 'CONFIRMED': {
        return css`
          background-color: ${theme.palette_success_5};
        `;
      }
      case 'PENDING': {
        return css`
          background-color: ${theme.palette_warning_5};
        `;
      }
      case 'SELECTED': {
        return css`
          background-color: ${theme.palette_gray_5};
        `;
      }
      case 'SUBMITTED': {
        return css`
          background-color: ${theme.palette_warning_5};
        `;
      }
      default: {
        return css``;
      }
    }
  }}
`;
